// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import Button from '@/components/button';
import Breadcrumbs from '@/components/breadcrumbs';
import Search from '@/components/search';
import Table from '@/components/table';
import { colors, fontSizes, layout, fontFamily, shadows } from '@/theme';
import CellStatus from '@/components/cells/status-old';
import CellDate from '@/components/cells/date';
import CellBold from '@/components/cells/bold';
import CellTech from '@/components/cells/tech';
import KendoPager from '@/components/kendo/kendo-pager';
import Pagination from '@/components/pagination';
import Router from 'next/router';
import Fetch from '@/utils/Fetch';
import SettingsMenu from '@/components/settings/menu';
import LookupSubMenu from '@/components/lookup/sub-menu';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import { createFileRoute } from '@tanstack/react-router'

function OptionList() {

  let currPath = '';
  if (Router.router) {
    currPath = Router.router.asPath;
  }

  const router = useRouter();
  const [type, setType] = useState('customerType');

  useEffect(() => {
    if (router.query.type) { // TODO(tanstack-router): verify router.query → useParams/useSearch
      setType((router as any).query.type);
    }
  }, [router.query.type]); // TODO(tanstack-router): verify router.query → useParams/useSearch
  const [title, setTitle] = useState('Customer Type');

  const [buttonText, setButtonText] = useState(`Create ${title}`);
  const [createLink, setCreateLink] = useState(`/settings/option/create?type=${type}`);

  const [columnState, setColumnState] = useState<any>();
  const [results, setResults] = useState<any>();

  const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);
  
  const getAccessStatus = () => {
    let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
    if (subscriptionInfo) {
      setAccessStatus(subscriptionInfo.AccessStatus);
    }
  };

  const [pageSize, setPageSize] = useState(10);
  
  const pageSizeChanged = (size: any) => {
    setPageSize(size);
  };

  const pageChanged = (page: any) => {
    setCurrentPage(page);
  };

  useEffect(() => {
    getAccessStatus();
  }, []);

  useEffect(() => {
    if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
      Helper.nextRouter(Router.replace,"/");
    }
  }, [accessStatus]);

  function getColumns() {
    let columns = [];
    switch (type) {
      case 'customerType':
      case 'customerStatus':
      case 'industryType':
      case 'mediaType':
      case 'queryType':
      case 'queryReason':
      case 'designation':
        columns = [{
          Label: 'Description',
          ColumnName: 'Description',
          CellType: 'none',
        }, {
          Label: 'Updated By',
          ColumnName: 'ModifiedBy',
          CellType: 'none',
        }, {
          Label: 'Updated Date',
          ColumnName: 'ModifiedDate',
          CellType: 'date',
        }];
        break;
      case 'queryStatus':
        columns = [{
          Label: 'Description',
          ColumnName: 'Description',
          CellType: 'none',
        }, {
          Label: 'Query Type',
          ColumnName: 'QueryTypeDescription',
          CellType: 'status',
        }, {
          Label: 'Updated By',
          ColumnName: 'ModifiedBy',
          CellType: 'none',
        }, {
          Label: 'Updated Date',
          ColumnName: 'ModifiedDate',
          CellType: 'date',
        }];
        break;
      case 'faultCause':
      case 'faultReason':
        columns = [{
          Label: 'Code',
          ColumnName: 'Code',
          CellType: 'none',
        }, {
          Label: 'Description',
          ColumnName: 'Description',
          CellType: 'none',
        }, {
          Label: 'Updated By',
          ColumnName: 'ModifiedBy',
          CellType: 'none',
        }, {
          Label: 'Updated Date',
          ColumnName: 'ModifiedDate',
          CellType: 'date',
        }];
        break;
      case 'faultCode':
        columns = [{
          Label: 'Code',
          ColumnName: 'Code',
          CellType: 'none',
        }, {
          Label: 'Description',
          ColumnName: 'Description',
          CellType: 'none',
        }, {
          Label: 'Inventory Category',
          ColumnName: 'InventoryCategoryDescription',
          CellType: 'none',
        }, {
          Label: 'Updated By',
          ColumnName: 'ModifiedBy',
          CellType: 'none',
        }, {
          Label: 'Updated Date',
          ColumnName: 'ModifiedDate',
          CellType: 'date',
        }];
        break;
    }
    setColumnState(columns);
  }

  const [searching, setSearching] = useState(false);
  const [sortField, setSortField] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [searchVal, setSearchVal] = useState('');
  const [totalResults, setTotalResults] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const columns = React.useMemo(
    () => columnState && columnState.map(function (column: any) {
      let columnObject = {
        Header: column.Label,
        accessor: column.ColumnName,
      }

      if (column.CellType != "none") {
        switch (column.CellType) {
          case 'employee':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellTech value={value} />;
            break;
          case 'date':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellDate value={value} />;
            break;
          case 'status':
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellStatus value={value} />;
            break;
          default:
            columnObject['Cell'] = ({ cell: { value } }: any) => <CellBold value={value} />;
        }
      }

      return columnObject;
    }),
    [columnState]
  );

  useEffect(() => {
    getColumns();
    searchData();
  }, [type]);

  useEffect(() => {
    if (currentPage == 1) {
      searchData();
    } else {
      setCurrentPage(1);
    }
  }, [sortField, sortDirection, pageSize]);

  useEffect(() => {
    searchData();
  }, [currentPage]);

  function setSort(field: any) {
    if (field != sortField) {
      setSortDirection('ascending');
    } else {
      if (sortDirection == 'ascending') {
        setSortDirection('descending');
      } else {
        setSortDirection('ascending');
      }
    }
    setSortField(field);
  }

  async function searchData() {
    setSearching(true);

    let url = '';
    let title = '';
    switch (type) {
      case 'customerType':
        url = '/CustomerType/GetCustomerTypes';
        title = 'Customer Type';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'customerStatus':
        url = '/CustomerStatus/GetCustomerStatus';
        title = 'Customer Status';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'industryType':
        url = '/IndustryType/GetIndustryTypes';
        title = 'Industry Type';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'mediaType':
        url = '/MediaType/GetMediaTypes';
        title = 'Media Type';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'queryType':
        url = '/QueryType/GetQueryTypes';
        title = 'Query Type';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'queryStatus':
        url = '/QueryStatus/GetQueryStatus';
        title = 'Query Status';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'queryReason':
        url = '/QueryReason/GetQueryReasons';
        title = 'Query Reason';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'designation':
        url = '/Designation/GetDesignations';
        title = 'Designation';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'faultCause':
        url = '/FaultCause/GetFaultCauses';
        title = 'Fault Cause';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'faultCode':
        url = '/FaultCode/GetFaultCodes';
        title = 'Fault Code';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
      case 'faultReason':
        url = '/FaultReason/GetFaultReasons';
        title = 'Fault Reason';
        setTitle(title);
        setButtonText(`Create ${title}`);
        setCreateLink(`/settings/option/create?type=${type}`);
        break;
    }

    const data = await Fetch.post({
      url: url,
      params: {
        pageSize: pageSize,
        pageIndex: (currentPage - 1),
        searchPhrase: searchVal,
        SortExpression: sortField,
        SortDirection: sortDirection,
      }
    });
    setResults(data.Results);
    setTotalResults(data.TotalResults);

    setSearching(false);
  }

  function rowClick(row: any) {
    Helper.nextRouter(Router.push,`/settings/option/[id]?type=${type}`, `/settings/option/${row.original.ID}?type=${type}`);
  }

  const createOption = () => {
    Helper.nextRouter(Router.push,createLink);
  }

  return (
    <div className="settings-container">
      <div className="row">
        <SettingsMenu urlPath={currPath} />
        <LookupSubMenu type={type} setType={setType} />
        <div className="settings-card">
          <div className="list-box">
            <h1>{title}</h1>
            <div className="row end">
              <div className="search-container">
                <Search
                  placeholder="Search"
                  resultsNum={results ? results.length : 0}
                  searchVal={searchVal}
                  setSearchVal={setSearchVal}
                  searchFunc={searchData}
                />
              </div>
              <Button disabled={accessStatus === Enums.AccessStatus.LockedWithAccess || accessStatus === Enums.AccessStatus.LockedWithOutAccess}
                text={buttonText} icon="plus-circle" extraClasses="fit-content no-margin" onClick={createOption} />
            </div>

            <div className={"no-items" + (results && results.length == 0 ? " no-items-visible" : "")}>
              <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
                <div className="loader"></div>
              </div>
              <img src="/job-folder.svg" alt="Folder" />
              <h3>No {title} found</h3>
              <p>If you can't find a {title}, try another search or create a new one.</p>
              {accessStatus !== Enums.AccessStatus.LockedWithAccess && accessStatus !== Enums.AccessStatus.LockedWithOutAccess ? <>
                <a href={createLink}><img src="/icons/plus-circle-blue.svg" alt="plus" /> Add new {title}</a>
              </> : ""}
              <img className="wave" src="/wave.svg" alt="wave" />
            </div>

            <div className={"table-container" + (columns && results && results.length != 0 ? " table-container-visible" : "")}>
              <div className={"loading-overlay" + (searching ? " loading-overlay-visible" : "")}>
                <div className="loader"></div>
              </div>
              {columns && results ?
                <Table actions={[
                  { text: "Edit", icon: "edit", function: (row: any) => Helper.nextRouter(Router.push,`/settings/option/[id]?type=${type}`, `/settings/option/${row.ID}?type=${type}`) },
                ]}
                  columns={columns} data={results} setSort={setSort} sortField={sortField} sortDirection={sortDirection}
                  rowClick={rowClick} /> : ''
              }
            </div>
            <KendoPager pageSizeChanged={pageSizeChanged} pageChanged={pageChanged} totalResults={totalResults} searchValue={searchVal} parentPageNumber={currentPage} />

          </div>

        </div>
      </div>

      <style jsx>{`
        .type {
          align-items: center;
          background-color: rgba(28,37,44,0.2);
          border-radius: ${layout.buttonRadius};
          box-sizing: border-box;
          color: ${colors.darkPrimary};
          cursor: pointer;
          display: flex;
          font-size: 0.875rem;
          font-weight: bold;
          height: 3rem;
          justify-content: center;
          padding: 0 1rem;
          text-align: center;
        }
        .type-container {
          background-color: ${colors.white};
          border-radius: ${layout.buttonRadius};
          height: 3rem;
          margin: 1rem 0 0 1rem;
          width: calc(25% - 1rem);
        }
        .types {
          display: flex;
          flex-wrap: wrap;
          margin: 0 0 0 -1rem;
        }
        .list-box {
          border: 1px solid rgba(255, 255, 255, 0.7);
          border-radius: ${layout.cardRadius};
          margin-top: 1.5rem;
          padding: 1rem;
          position: relative;
        }
        .list-box h1 {
          color: ${colors.darkPrimary};
          font-size: 1.5rem;
          font-weight: normal;
          margin: 0 0 0.5rem;
        }
        .column {
          width: 100%;
        }
        .column-margin {
          margin-left: 24px;
        }
        .button-container {
          flex-shrink: 0;
          width: 15rem;
        }
        .button-container :global(.button){
          margin-top: 0.5rem;
        }
        .row {
          display: flex;
          justify-content: space-between;
        }
        .end {
          align-items: flex-end;
        }
        .row.top-gap {
          margin-top: 2.5rem;
        }
        .search-container :global(.search) {
          width: 528px;
        }
        a {
          text-decoration: none;
        }
      `}</style>
    </div>
  );
}

export default OptionList

export const Route = createFileRoute('/_authenticated/settings/option/list')({ component: OptionList })
